import { ChangeEvent, FC } from 'react';
import { Box, TextField, Typography } from '@material-ui/core';
import { ErrorMessage, Field } from 'formik';
import { useStyles } from '../../styles';

interface Props {
    value: number;
    setFieldValue: (fieldName: string, value: string) => void;
}

const PriceField: FC<Props> = ({ value, setFieldValue }) => {
    const classes = useStyles();

    return (
        <Box className={classes.row}>
            <Typography className={classes.label}>Price per ticket ($)</Typography>
            <Field
                type="number"
                placeholder="Max 49"
                component={TextField}
                autoComplete="off"
                variant="outlined"
                value={value || '0'}
                onChange={(e: ChangeEvent<HTMLInputElement>) => {
                    setFieldValue(
                        'price',
                        parseInt(e.target.value, 10) > 0 ? parseInt(e.target.value, 10).toString() : '0',
                    );
                }}
                InputProps={{ name: 'price', classes: { root: classes.field, input: classes.centeredField } }}
                fullWidth
            />
            <p className={classes.errorText}>
                <ErrorMessage name="price" />
            </p>
        </Box>
    );
};

export default PriceField;
